module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m7-e4a9ceab0fa509ae50914d5cf53bd9c1.png";